import { MODULE_REDUCER_KEY } from 'constants/reducer';

import { KEY } from '../reducers';

export const selectMainState = (state) => state[MODULE_REDUCER_KEY][KEY];
